/**
 * This will match markdown which appears to end with a custom tag,
 * e.g.
 * * Something something <
 * * Something something <c
 * * Something something <cust
 * * Something something <custom
 * and will match content until a closing tag (</custom>) has been found.
 *
 * This won't match non-custom tags e.g.
 * <custard
 * <status
 * etc.
 */
export const isMarkdownEndingWithCustomTag = (markdown: string, streamingV2?: boolean): boolean => {
	if (streamingV2) {
		return !!markdown.match(/<(c(u(s(t(o(m(?!.*<\/custom>|.*\/>).*?)?)?)?)?)?)?$/g);
	} else {
		return !!markdown.match(/<(c(u(s(t(o(m(?!.*<\/custom>).*?)?)?)?)?)?)?$/g);
	}
};
